import React from 'react';
import { Routes } from 'services/route';

export const authRoutes: Routes = [
  {
    path: 'login',
    component: React.lazy(() => import('pages/auth/login')),
  },
  {
    path: 'reset-password',
    component: React.lazy(() => import('pages/auth/reset-password')),
  },
  {
    path: 'send-email',
    component: React.lazy(() => import('pages/auth/send-email')),
  },
  {
    path: 'reset-success',
    component: React.lazy(() => import('pages/auth/reset-password-success')),
  },
];
